import styles from "./button.module.scss";

export default function Button({ label, handleClick, isValid = "true" }) {
  return (
    <button
      className={styles.primary_btn}
      onClick={handleClick}
      disabled={!isValid}
    >
      {label}
    </button>
  );
}
